export default {
  apiUrl: 'https://clearfronthr.herokuapp.com/api/v1/',
};
const goGlobalToken = {
  go_token: process.env.GOGLOBAL_API_KEY_CLIENT,
};
const siteConfig = {
  siteName: 'Clearfront HR',
  siteIcon: 'ion-flash',
  footerText: '© 2018 Clearfront HR, Inc.  All rights reserved.',
};

const themeConfig = {
  topbar: 'themedefault',
  sidebar: 'themedefault',
  layout: 'themedefault',
};
const language = 'english';
const Auth0Config = {
  domain: '',
  clientID: '', //
  options: {
    auth: {
      autoParseHash: true,
      redirect: false,
    },
    languageDictionary: {
      title: 'ClearFrontHR',
      emailInputPlaceholder: 'demo@gmail.com',
      passwordInputPlaceholder: 'demodemo',
    },
    icon: '',
    theme: {
      labeledSubmitButton: true,
      logo: '',
      primaryColor: '#E14615',
      authButtons: {
        connectionName: {
          displayName: 'Log In',
          primaryColor: '#b7b7b7',
          foregroundColor: '#000000',
          icon: undefined,
        },
      },
    },
  },
};
const googleConfig = {
  apiKey: '', //
};
const mapboxConfig = {
  tileLayer: '',
  accessToken: '',
  id: '',
  maxZoom: '',
  defaultZoom: '',
  center: [],
};
export {
  siteConfig,
  themeConfig,
  language,
  Auth0Config,
  googleConfig,
  mapboxConfig,
  goGlobalToken,
};



// WEBPACK FOOTER //
// ./src/config.js